import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { format, formatISO } from 'date-fns';
@Component({ 
  selector: 'app-calender',
  templateUrl: './calender.page.html',
  styleUrls: ['./calender.page.scss'],
})
export class CalenderPage implements OnInit {

  @Input('type') type = '';

  date = formatISO(new Date());
  calenderDate = formatISO(new Date()).split('+')[0];

  constructor(
    private router : Router,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    console.log(this.calenderDate);
    
  }

  async changeDate(dateVal: any) {
    this.date = dateVal;
    
    // this.modalCtrl.dismiss(this.date);
  }


  saveDate(){
    console.log(this.date);
    console.log(new Date(this.date));
    this.modalCtrl.dismiss(new Date(this.date));
  }
}
